const ActionTitle = new Map([
    ['Action.Http', 'Submit'],
    ['Action.ShowCard', 'Add a comment'],
    ['Action.OpenUrl', 'View in Portal'],
    ['Action.ToggleVisibility', 'View More']
]);

export default ActionTitle;
